/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BusinessPeriod } from './BusinessPeriod';
import {
    BusinessPeriodFromJSON,
    BusinessPeriodFromJSONTyped,
    BusinessPeriodToJSON,
    BusinessPeriodToJSONTyped,
} from './BusinessPeriod';

/**
 * 
 * @export
 * @interface BusinessServiceAvailability
 */
export interface BusinessServiceAvailability {
    /**
     * 
     * @type {string}
     * @memberof BusinessServiceAvailability
     */
    dayOfWeek: string;
    /**
     * 
     * @type {Array<BusinessPeriod>}
     * @memberof BusinessServiceAvailability
     */
    timePeriods: Array<BusinessPeriod>;
}

/**
 * Check if a given object implements the BusinessServiceAvailability interface.
 */
export function instanceOfBusinessServiceAvailability(value: object): value is BusinessServiceAvailability {
    if (!('dayOfWeek' in value) || value['dayOfWeek'] === undefined) return false;
    if (!('timePeriods' in value) || value['timePeriods'] === undefined) return false;
    return true;
}

export function BusinessServiceAvailabilityFromJSON(json: any): BusinessServiceAvailability {
    return BusinessServiceAvailabilityFromJSONTyped(json, false);
}

export function BusinessServiceAvailabilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessServiceAvailability {
    if (json == null) {
        return json;
    }
    return {
        
        'dayOfWeek': json['dayOfWeek'],
        'timePeriods': ((json['timePeriods'] as Array<any>).map(BusinessPeriodFromJSON)),
    };
}

export function BusinessServiceAvailabilityToJSON(json: any): BusinessServiceAvailability {
    return BusinessServiceAvailabilityToJSONTyped(json, false);
}

export function BusinessServiceAvailabilityToJSONTyped(value?: BusinessServiceAvailability | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dayOfWeek': value['dayOfWeek'],
        'timePeriods': ((value['timePeriods'] as Array<any>).map(BusinessPeriodToJSON)),
    };
}

